import { Button } from '@/components/shadcn/button';
import { logError } from '@/lib/rum';
import { env } from 'next-runtime-env';
import { useEffect } from 'react';

const Custom404 = () => {
  useEffect(() => {
    logError('Page not found');
  }, []);

  return (
    <div className='flex flex-1 flex-col items-center justify-center pt-24'>
      <h1>404, Page not found</h1>
      <div className='mt-12 text-2xl'>{`We recommend starting again from home.`}</div>

      <Button
        className='mt-10'
        onClick={() => {
          window.location.href = env('WEBSITE') || '/';
        }}
      >
        Home
      </Button>
    </div>
  );
};

export default Custom404;
